import React from 'react';

import './MenuRight.scss';
import {logout, getInitialState} from '../../Authorization/authSlice';
import { getInitialStateData } from '../../FirstMain/userSlice';
import { getInitialStateMenu } from '../../Menu/MenuSide/menuSideSlice';
import { getInitialStateAccount } from '../../MainVIew/Account/accountSlice';
import { closeAdminView } from '../../Admin/adminSlice';
import { getInitialStateMessages } from '../../MainVIew/Messages/messageslice';
import { getInitialStateContacts } from '../../MainVIew/Contacts/contactsSlice';
import { getInitialStateForAdmin } from '../../Admin/adminSlice';
import { getInitialStateForTasks } from '../../MainVIew/Tasks/taskSlice';

const MenuRight = (props) => {
    const { dispatch } = props;   
    


// HANDLER
const onSend = () => {
     
    dispatch(logout());
    dispatch(getInitialState());
    dispatch(getInitialStateAccount());
    dispatch(getInitialStateData());
    dispatch(getInitialStateMenu());
    dispatch(getInitialStateMessages());
    dispatch(closeAdminView());
    dispatch(getInitialStateContacts());
    dispatch(getInitialStateForAdmin());
    dispatch(getInitialStateForTasks());

}
//RENDER MENU FOR ADMIN USERS
    const renderMenuRightAdmin = () => {
        return (
            <div className="MenuRight">
                <button id="admin" onClick={props.adminViewChange}></button>
               
                {/* <button id="exit1"><i class="fas fa-sign-out-alt fa-2x"></i></button> */}
                
                <button id="exit" onClick={onSend}></button>

            </div>
        )
    }
    //RENDER MENU FOR COMMOM USERS
    const renderMenuRightCommon = () => {
        return (
            <div className="MenuRight">
                <button id="exit" onClick={onSend}></button>

            </div>
        )
    }


    
    const renderMenuRight = (condition) => {
        if (condition === 1 || condition === 3) {
            return renderMenuRightAdmin();
        } else { return renderMenuRightCommon()};
       
    }


// RENDER MENU
const userRole = Number(props.userRole[0].role_id);
//const userRole = 1;
console.log(userRole);
  
       return  renderMenuRight(userRole);   
}

export default  MenuRight;